module.exports = __webpack_public_path__ + "img/ind-zyjk.a2410327.png";